import { render, staticRenderFns } from "./HowToTour.vue?vue&type=template&id=ece24200&scoped=true&lang=pug"
import script from "./HowToTour.vue?vue&type=script&lang=js"
export * from "./HowToTour.vue?vue&type=script&lang=js"
import style0 from "./HowToTour.vue?vue&type=style&index=0&id=ece24200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece24200",
  null
  
)

export default component.exports